// extracted by mini-css-extract-plugin
export default {"highlight":"highLighter_highlight__Fn7cT"};